/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import { getGlyphName } from 'lib/FileTypes';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import File from 'entities/File';
import ModalTrigger from 'components/ModalTrigger.jsx';
import ImageFilePreviewModal from 'components/ImageFilePreviewModal.jsx';
import cx from 'classnames';
import './styles/ComposerFilePreview.scss';

class ComposerFilePreview extends React.Component {
  static propTypes = {
    progress: React.PropTypes.number,
    thumbnail: React.PropTypes.string,
    type: React.PropTypes.string,
    onDelete: React.PropTypes.func,
    onRetry: React.PropTypes.func,
    error: React.PropTypes.bool,
    file: React.PropTypes.instanceOf(File),
  };

  static defaultProps = { progress: 0, error: false };

  // If only I could put quotes around "Progress"
  getProgress = () => {
    if (this.props.error) {
      return 0;
    }
    const percent = (this.props.progress / 100) ** 0.7;
    return Math.floor(percent * 100);
  };

  // When editing an announcement that has an image attachement,
  // we don't have the thumbnail that we usually have during uploading,
  // but we can display the image itself as a pseudo-thumbnail
  isFileThumbnail = () => {
    const { file } = this.props;
    return file && Image.isSupportedType(file.getContentType());
  };

  renderPreview = () => {
    const { file } = this.props;

    let preview = null;
    if (this.props.thumbnail) {
      preview = <Image className="ComposerFilePreview-image" src={this.props.thumbnail} />;
    } else if (this.isFileThumbnail()) {
      preview = (
        <div
          className={cx(
            'ComposerFilePreview-image',
            'ComposerFilePreview-imageBackground'
          )}
          style={{
            background: `url("${file.getUrls().cdn}")`,
            backgroundSize: 'cover',
          }}
        />
      );
    } else {
      preview = (
        <Glyph
          className="ComposerFilePreview-glyph"
          name={getGlyphName(this.props.type)}
          size="xlarge"
          solo
        />
      );
    }

    if (file) {
      const url = file.getUrls().cdn;
      if (Image.isSupportedType(file.getContentType())) {
        const modal = (<ImageFilePreviewModal file={file} />);
        preview = (
          <ModalTrigger modal={modal}>
            <Link
              className="MessageItemAttachment-image"
              href={url}
              target="_blank"
              eventElementName="MessageItemAttachment-image">
              {preview}
            </Link>
          </ModalTrigger>
        );
      } else {
        preview = (
          <Link
            className="MessageItemAttachment-icon"
            href={url}
            target="_blank"
            eventElementName="MessageItemAttachment-icon">
            {preview}
          </Link>
        );
      }
    }

    return preview;
  };

  renderStatus = () => {
    if (this.props.error) {
      return (
        <div>
          <Glyph name="caution" color="lava" />
          {' '}
          Upload error.
          {' '}
          <Link color="inherit" weight="semibold" onClick={this.props.onRetry}>Retry</Link>
          {' '}
          or
          {' '}
          <Link color="inherit" weight="semibold" onClick={this.props.onDelete}>Cancel</Link>?
        </div>
      );
    }
    if (this.props.progress < 100) {
      return (
        <div>
          <span className="ComposerFilePreview-progress">
            Uploading… {this.getProgress()}%
          </span>
          <Button
            className="ComposerFilePreview-cancelUploadButton"
            level="text"
            color="brand"
            onClick={this.props.onDelete}
            eventElementName="ComposerFilePreview-cancelUploadButton">
            <Glyph name="close-circle" size="xlarge" solo />
          </Button>
        </div>
      );
    } else if (this.props.onDelete) {
      return (
        <Button
          className="ComposerFilePreview-cancelAttachButton"
          level="text"
          color="brand"
          onClick={this.props.onDelete}
          eventElementName="ComposerFilePreview-cancelAttachButton">
          <Glyph name="close-circle" size="xlarge" solo />
        </Button>
      );
    }
  };

  render() {
    const preview = this.renderPreview();
    const status = this.renderStatus();
    return (
      <div className="ComposerFilePreview">
        <div
          className={cx({
            'ComposerFilePreview-preview': true,
            'ComposerFilePreview-previewNoThumbnail':
            !(this.props.thumbnail || this.isFileThumbnail()),
          })}>
          {preview}
          <div
            className="ComposerFilePreview-mask"
            style={{ width: (100 - this.getProgress()) + '%' }}
          />
        </div>
        <div className="ComposerFilePreview-status">
          {status}
        </div>
      </div>
    );
  }
}

export default ComposerFilePreview;



// WEBPACK FOOTER //
// ./src/chat/components/ComposerFilePreview.jsx